import { Auth } from 'aws-amplify';
import * as V from '../constants/variables';

/**
 * Поиск парковки по parking_id или internal_id
 * @param {string} id - parking_id или internal_id
 * @returns {Promise<{id: string, lat: number, lon: number, status: string} | null>}
 */
export async function fetchParkingId (id) {
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();
    const url = `${V.API_GW_URL}/parking-id?parkingId=${encodeURIComponent(id)}`;
    const response = await fetch(url, {
        headers: { Authorization: token },
    });
    if (!response.ok) return null;
    const data = await response.json();
    // API возвращает объект с полем parkings, которое содержит массив
    const parkings = data.parkings || data;
    const parking = Array.isArray(parkings) ? parkings[0] : parkings;

    if (!parking || !parking.parking_id || typeof parking.lat !== 'number' || typeof parking.lon !== 'number') return null;

    return {
        id: parking.parking_id,
        lat: parking.lat,
        lon: parking.lon,
        status: parking.status,
    };
}
